import MensualConsumptionWidget from './MensualConsumptionWidget';

export default MensualConsumptionWidget;
